import EntityServise from "./entityService";

class EnvironmentService extends EntityServise {
    constructor() {
        super("environment")
    }

    async getByUser() {
        return await this.http.get("user/environments");
    }
}

export default new EnvironmentService();